import React, { Fragment, useState } from 'react';
import { array, object } from 'prop-types';

import {
  Title,
  Arrow,
  DividerS,
  HeaderWrapper,
  PopoverWrapper,
  ShowFeedbacksBtn,
  FeedbacksListWrapper,
  ShowFeedbacksBtnWrapper,
  ParticipantsListWrapper,
} from './styles';

import { Feedback } from './feedback';
import { ParticipantsList } from '../participants-list';


export function Feedbacks({
  users,
  contacts,
  feedbacks,
  participants,
}) {
  const [showFeedbacks, setShowFeedbacks] = useState(false);

  const contactsArray = Object.values(contacts);
  const participantsIds = [...participants.users, ...participants.contacts];

  return (
    <PopoverWrapper
      onClick={(e) => { e.stopPropagation(); }}
    >
      <HeaderWrapper>
        <Title>Meeting participants</Title>
      </HeaderWrapper>
      <ParticipantsListWrapper>
        {
          participantsIds.length
          && <ParticipantsList
            wrapperStyles
            users={users}
            contacts={contacts}
            participants={participantsIds}
          />
        }

        <ShowFeedbacksBtnWrapper>
          <ShowFeedbacksBtn
            onClick={() => setShowFeedbacks(!showFeedbacks)}
          >
            Show Feedback
            <Arrow type="down" rotate={showFeedbacks ? 180 : 0} />
          </ShowFeedbacksBtn>
        </ShowFeedbacksBtnWrapper>

        {
          showFeedbacks && (
            <FeedbacksListWrapper>
              {
                feedbacks.map((feedback, index) => {
                  const { contactId } = feedback;

                  const contactInfo = contactsArray.filter(el => el._id === contactId);

                  return (
                    <Fragment>
                      <Feedback
                        feedback={feedback}
                        contact={contactInfo[0]}
                      />
                      {index < feedbacks.length - 1 && <DividerS />}

                    </Fragment>
                  );
                })
              }
            </FeedbacksListWrapper>
          )}
      </ParticipantsListWrapper>
    </PopoverWrapper>
  );
}

Feedbacks.propTypes = {
  users: object.isRequired,
  contacts: object.isRequired,
  feedbacks: array.isRequired,
  participants: object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/feedbacks/index.js